export enum ScreeningType {
  ALL = 'all',
  MOVIE = 'movie',
  EVENT = 'event',
}
